"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessCategoryGroup = exports.BusinessCategory = exports.BusinessCategoryGrouping = exports.BusinessCategoryGroupLabels = exports.businessCategoryGroups = exports.BusinessCategoryLabels = exports.businessCategories = void 0;
const typebox_1 = require("@sinclair/typebox");
// All business category subcategories (27 total)
exports.businessCategories = [
    // Construction & Renovation
    'generalContractors',
    'homebuilders',
    'roofingCompanies',
    'demolitionContractors',
    'landscapingHardscaping',
    'remodelingRenovation',
    'masonryConcrete',
    // Commercial & Industrial
    'manufacturingPlants',
    'warehousesDistribution',
    'automotiveRepairShops',
    'retailStores',
    'restaurants',
    'officeBuildings',
    // Property & Real Estate
    'propertyManagementCompanies',
    'apartmentComplexes',
    'realtorsPreSaleCleanouts',
    'storageFacilities',
    // Municipal & Institutional
    'schoolsCollegesUniversities',
    'hospitalsMedicalCenters',
    'governmentBuildings',
    'parksRecreation',
    'publicWorks',
    // Specialty Services
    'junkRemovalCompanies',
    'eventOrganizers',
    'disasterCleanupRestoration',
    // Residential (Homeowners)
    'homeCleanouts',
    'diyRenovationProjects',
    'majorLandscapingProjects',
];
// Display labels for each business category
exports.BusinessCategoryLabels = {
    // Construction & Renovation
    generalContractors: 'General contractors',
    homebuilders: 'Homebuilders',
    roofingCompanies: 'Roofing companies',
    demolitionContractors: 'Demolition contractors',
    landscapingHardscaping: 'Landscaping and hardscaping companies',
    remodelingRenovation: 'Remodeling/renovation contractors',
    masonryConcrete: 'Masonry and concrete companies',
    // Commercial & Industrial
    manufacturingPlants: 'Manufacturing plants',
    warehousesDistribution: 'Warehouses and distribution centers',
    automotiveRepairShops: 'Automotive repair shops and body shops',
    retailStores: 'Retail stores (especially during remodels or closings)',
    restaurants: 'Restaurants (for cleanouts or major renovations)',
    officeBuildings: 'Office buildings (during tenant turnover or renovation)',
    // Property & Real Estate
    propertyManagementCompanies: 'Property management companies',
    apartmentComplexes: 'Apartment complexes',
    realtorsPreSaleCleanouts: 'Realtors (pre-sale cleanouts)',
    storageFacilities: 'Storage facilities (cleanouts and abandoned units)',
    // Municipal & Institutional
    schoolsCollegesUniversities: 'Schools, colleges, and universities',
    hospitalsMedicalCenters: 'Hospitals and medical centers',
    governmentBuildings: 'Government buildings',
    parksRecreation: 'Parks and recreation departments',
    publicWorks: 'Public works departments',
    // Specialty Services
    junkRemovalCompanies: 'Junk removal companies',
    eventOrganizers: 'Event organizers (large festivals, fairs, or community events)',
    disasterCleanupRestoration: 'Disaster cleanup/restoration companies',
    // Residential (Homeowners)
    homeCleanouts: 'Large home cleanouts (estate, downsizing, spring cleaning)',
    diyRenovationProjects: 'DIY renovation projects',
    majorLandscapingProjects: 'Major landscaping projects',
};
// Group definitions
exports.businessCategoryGroups = [
    'constructionRenovation',
    'commercialIndustrial',
    'propertyRealEstate',
    'municipalInstitutional',
    'specialtyServices',
    'residential',
];
// Display labels for groups
exports.BusinessCategoryGroupLabels = {
    constructionRenovation: 'Construction & Renovation',
    commercialIndustrial: 'Commercial & Industrial',
    propertyRealEstate: 'Property & Real Estate',
    municipalInstitutional: 'Municipal & Institutional',
    specialtyServices: 'Specialty Services',
    residential: 'Residential (Homeowners)',
};
// Mapping of categories to their parent groups
exports.BusinessCategoryGrouping = {
    // Construction & Renovation
    generalContractors: 'constructionRenovation',
    homebuilders: 'constructionRenovation',
    roofingCompanies: 'constructionRenovation',
    demolitionContractors: 'constructionRenovation',
    landscapingHardscaping: 'constructionRenovation',
    remodelingRenovation: 'constructionRenovation',
    masonryConcrete: 'constructionRenovation',
    // Commercial & Industrial
    manufacturingPlants: 'commercialIndustrial',
    warehousesDistribution: 'commercialIndustrial',
    automotiveRepairShops: 'commercialIndustrial',
    retailStores: 'commercialIndustrial',
    restaurants: 'commercialIndustrial',
    officeBuildings: 'commercialIndustrial',
    // Property & Real Estate
    propertyManagementCompanies: 'propertyRealEstate',
    apartmentComplexes: 'propertyRealEstate',
    realtorsPreSaleCleanouts: 'propertyRealEstate',
    storageFacilities: 'propertyRealEstate',
    // Municipal & Institutional
    schoolsCollegesUniversities: 'municipalInstitutional',
    hospitalsMedicalCenters: 'municipalInstitutional',
    governmentBuildings: 'municipalInstitutional',
    parksRecreation: 'municipalInstitutional',
    publicWorks: 'municipalInstitutional',
    // Specialty Services
    junkRemovalCompanies: 'specialtyServices',
    eventOrganizers: 'specialtyServices',
    disasterCleanupRestoration: 'specialtyServices',
    // Residential (Homeowners)
    homeCleanouts: 'residential',
    diyRenovationProjects: 'residential',
    majorLandscapingProjects: 'residential',
};
// TypeBox schema and TypeScript types
exports.BusinessCategory = typebox_1.Type.Union(exports.businessCategories.map((value) => typebox_1.Type.Literal(value)));
exports.BusinessCategoryGroup = typebox_1.Type.Union(exports.businessCategoryGroups.map((value) => typebox_1.Type.Literal(value)));
//# sourceMappingURL=business-category.js.map